import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from "@angular/material/icon";
import {ImageUploadComponent} from "../image/image-upload.component";
import {MatIconButton} from "@angular/material/button";
import {PatientInfo} from "@allaihealth/util";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {SurveyQuestions} from "@allaihealth/survey";

/** The insurance information for a patient */
@Component({
	selector: 'app-insurance-input',
	imports: [
		CommonModule,
		MatFormFieldModule,
		MatSelectModule,
		MatInputModule,
		FormsModule,
		MatIconModule,
		ImageUploadComponent,
		MatIconButton
	],
	templateUrl: './insurance-input.component.html',
	styleUrl: './insurance-input.component.scss',
})


export class InsuranceInputComponent implements OnInit {
	@Input() patientInfo: PatientInfo;
	@Input() insurance: any = {};
	@Input() insuranceType: string = '';
	@Input() canDelete: boolean = false;

	imageSrcFront:string | ArrayBuffer | null = null;
	imageSrcBack:string | ArrayBuffer | null = null;

	constructor(private http: HttpClient) {
	}
	async ngOnInit() {
		if(this.insurance) {

			if(this.insurance[SurveyQuestions.SrcFrontId]) {
				this.http.get<{ url:string }>(`${environment.apiUrl}/patient/${this.patientInfo.patientId}/image/${this.insurance[SurveyQuestions.SrcFrontId]}`).subscribe((value) => {
					fetch(value.url).then(response =>{
						response.text().then(text => {
							this.imageSrcFront = text;
						})
					});
				});
			}

			if(this.insurance[SurveyQuestions.SrcBackId]) {
				this.http.get<{ url:string }>(`${environment.apiUrl}/patient/${this.patientInfo.patientId}/image/${this.insurance[SurveyQuestions.SrcBackId]}`).subscribe((value) => {
					fetch(value.url).then(response =>{
						response.text().then(text => {
							this.imageSrcBack = text;
						})
					});
				});
			}

		}
	}
	protected deleteInsurance() {
		this.patientInfo.data.insurances.splice(this.patientInfo.data.insurances.indexOf(this.insurance), 1);
	}

	protected readonly SurveyQuestions = SurveyQuestions;
}
